import "src/pages/DataVault/Entities/components/EntityDetailModal/styles_vanilla.css.ts.vanilla.css!=!../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/DataVault/Entities/components/EntityDetailModal/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA8VZ226kOBB9z1dYilZKpKFl0w1N6Jf9k5XBhnYCmDXuS7LKv69scNo20LdkZ0czEwmXq07dy5XFX-j1I6alhOCfBwBqfAwOjMhtClAIYXvcPAAwfHiB-8Pm4fNhYa4gfSXjglARZFxKXqcAtUfQ8YoR8FiEBaKF4pDh_K0UfNeQIOcVFyl4LPSfzYmB5G1Q0UIGAhO26xSAXrx1Lli59QksQKEGVPBGBgeqSFMQQ6h4GKkhRAXKN1pTUbImBdDhsNQcWkwIa0p9CMB2YJXjKn9CEO63IABoCdvjszrmeyqKih9SgHeSX9DWErXSogjr2gq_p6Co6NGWhiD8w6GPNP3gi6XxzZSsdREXkWU5MXCc8syXquGqZ6hwBN1WsObNN048jVjfIEzQXDLepMrWu7pRJyVuDWOLzfouNij22CQ3OPvABQkyQfFbCvSPQH1x2L3chSrxQOExqMgFtQ7XKKbqi6RHGUiBm67gok7Brm2pyHGnDzWLjn3QFMDFOhK0Vl8rKiUVQdfivI_PBYzUiYUg0wh8E1gE-UW7RXBVrKwkOeW27wPiCDOqWQS0F1bRYwrQZLzVrDEVB14sFX6uWZKKaf-97jrJivcg542kjcpi2kgq1BGuWNkETNK6sz8rQCYJhxJoiSkvaby9NY5mYFhBP4npjGoWGubAzWKUL_FmMkKtS6-TOg4Bq-FOynr7Sc2TbypeOTqcIvqs4vV9ijc_U9D4_RXocqa2V1dL69Lfl4JduJBLwYgGJhgJJK3bCksa9IBVvy6E-ud1hq-e1nc8vyJY0rpv9J_rpcgrC4kWSxtiVTU1o5wEnuaWmd47-My6ZMHY_Rf1DJkUOuPTvTXVzY1zw1zhDWpftd2UrbO1XHc-1rss42rmwIQfAFygqAMUdzRgTcB38pcRp1mMzy_61m4be9axrNJJ_d1Wv0-3iu9gLYM_BVBBDFXHBnDR_xRlhp_gLzD8XcB19GzZ0dgmj_Moh56Qgue7LjgwuWWNPW-bS_E6z3O6GYPQQEIl_pHiYlWsHMaH_8HLuKoUpDnvhRG0RtBSKD3Qb3PnwXbnFUO1OaARXVH4pWo_ynU5rugTWsDw2RMycudHwBqixyOvGR2vLABqGKRBRuWB0nFb7cd5iYWc6BK-Dd7vKrCryQ7k8_64n7f95IT39DGE7roVXmp_aHmRYjU8q8_aBkW3GscreBMZYbOP3VdtYvcnO_l1BLdY0EZOFIDkij46k5x6gDqd7JqO9pm_ZZLq5wxNQcNFjSsX-XryNTMyqGnxM888T1AraHAQuL0ZrrUdaXhDR9awkSczs-TP2udnXq0I_wyb7DY29tV8OkSnWgshZDUdv49FkS2zaC52bXnkN8ujbjgkEIaxSzHzgJ22dGmXFT1Ajki2MwHYbxbke0VTwCSuWD6VcveHqZ1dtyRM_E25Jj1ukgoXNSe4Av2PgDBc8dJetPVLz5nFqBmrX-B-a4jG34Y943hl4QkfOrqW7m4B78spj33Gybu_jRnvLu3Vp-0dduWu177T7xHO71PQ29WJOFprun3p7Cx7rkVXszOft6K-bU52x3F1c9keR08B9Hz2LTQMyx7g2ZdH2B6VOcZSIncORfWUO8OTdubFcMET47fA2Bb9f9APqGY8kq3dkQzCKIkT9xZ3ihpE65fkxaVo3Xgyi5A_a0oYBk92HkP16H7W9N5G49wKY9Of2-u5z2kB6zgZ8YcDf1Neor68TBatT_siGi6OTO5QLQcqk3BJ1Fchh2g1EM23d4c8ciGbkuT_esGgvu43QpcUoVepe5O3kgkGe1_MQOQ-bT4fPv8FR_jhCSgbAAA\"}!../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var activeTabContent = '_1jz6egt1j';
export var editHint = '_1jz6egt18';
export var editorActions = '_1jz6egt1f';
export var editorInput = '_1jz6egt1b';
export var emptyContainer = '_1jz6egtk';
export var emptyFieldsList = '_1jz6egtu';
export var emptyMessage = '_1jz6egtm';
export var emptyTitle = '_1jz6egtl';
export var entityName = '_1jz6egt8';
export var entitySummary = '_1jz6egt6';
export var errorContainer = '_1jz6egth';
export var errorMessage = '_1jz6egtj';
export var errorText = '_1jz6egt1e';
export var errorTitle = '_1jz6egti';
export var fieldDescription = '_1jz6egt14';
export var fieldEditor = '_1jz6egt19';
export var fieldEditorAlwaysVisible = '_1jz6egt1a';
export var fieldHeader = '_1jz6egtx';
export var fieldHeaderGrid = '_1jz6egty';
export var fieldInfo = '_1jz6egtz';
export var fieldItem = '_1jz6egtv';
export var fieldItemGrid = '_1jz6egtw';
export var fieldLabel = '_1jz6egta';
export var fieldName = '_1jz6egt10';
export var fieldNameGrid = '_1jz6egt11';
export var fieldType = '_1jz6egt12';
export var fieldTypeGrid = '_1jz6egt13';
export var fieldValue = '_1jz6egt15';
export var fieldsContainer = '_1jz6egtr';
export var fieldsFormContainer = '_1jz6egts';
export var fieldsHeader = '_1jz6egto';
export var fieldsList = '_1jz6egtn';
export var fieldsSubtitle = '_1jz6egtq';
export var fieldsTitle = '_1jz6egtp';
export var hintText = '_1jz6egt1h';
export var keyboardHints = '_1jz6egt1g';
export var loadingContainer = '_1jz6egtf';
export var loadingText = '_1jz6egtg';
export var mainContent = '_1jz6egte';
export var modal = '_1jz6egt0';
export var modalBody = '_1jz6egt3';
export var modalContent = '_1jz6egt4';
export var modalHeader = '_1jz6egt1';
export var modalTitle = '_1jz6egt2';
export var saveButtonContainer = '_1jz6egtt';
export var saveError = '_1jz6egt1d';
export var sectionContainer = '_1jz6egt1l';
export var sectionDescription = '_1jz6egtd';
export var sectionDescriptionInTab = '_1jz6egt1o';
export var sectionFields = '_1jz6egt1p';
export var sectionHeader = '_1jz6egt1m';
export var sectionTitle = '_1jz6egtc';
export var sectionTitleInTab = '_1jz6egt1n';
export var sidebar = '_1jz6egt5';
export var summaryField = '_1jz6egt9';
export var summaryFieldValue = '_1jz6egtb';
export var summarySection = '_1jz6egt7';
export var tabDescription = '_1jz6egt1k';
export var tabsContainer = '_1jz6egt1i';
export var validationError = '_1jz6egt1c';
export var valueDisplay = '_1jz6egt16';
export var valueText = '_1jz6egt17';